import $hkbbV$intlcalendararAEmjs from "../intl/calendar/ar-AE.mjs";
import $hkbbV$intlcalendarbgBGmjs from "../intl/calendar/bg-BG.mjs";
import $hkbbV$intlcalendarcsCZmjs from "../intl/calendar/cs-CZ.mjs";
import $hkbbV$intlcalendardaDKmjs from "../intl/calendar/da-DK.mjs";
import $hkbbV$intlcalendardeDEmjs from "../intl/calendar/de-DE.mjs";
import $hkbbV$intlcalendarelGRmjs from "../intl/calendar/el-GR.mjs";
import $hkbbV$intlcalendarenUSmjs from "../intl/calendar/en-US.mjs";
import $hkbbV$intlcalendaresESmjs from "../intl/calendar/es-ES.mjs";
import $hkbbV$intlcalendaretEEmjs from "../intl/calendar/et-EE.mjs";
import $hkbbV$intlcalendarfiFImjs from "../intl/calendar/fi-FI.mjs";
import $hkbbV$intlcalendarfrFRmjs from "../intl/calendar/fr-FR.mjs";
import $hkbbV$intlcalendarheILmjs from "../intl/calendar/he-IL.mjs";
import $hkbbV$intlcalendarhrHRmjs from "../intl/calendar/hr-HR.mjs";
import $hkbbV$intlcalendarhuHUmjs from "../intl/calendar/hu-HU.mjs";
import $hkbbV$intlcalendaritITmjs from "../intl/calendar/it-IT.mjs";
import $hkbbV$intlcalendarjaJPmjs from "../intl/calendar/ja-JP.mjs";
import $hkbbV$intlcalendarkoKRmjs from "../intl/calendar/ko-KR.mjs";
import $hkbbV$intlcalendarltLTmjs from "../intl/calendar/lt-LT.mjs";
import $hkbbV$intlcalendarlvLVmjs from "../intl/calendar/lv-LV.mjs";
import $hkbbV$intlcalendarnbNOmjs from "../intl/calendar/nb-NO.mjs";
import $hkbbV$intlcalendarnlNLmjs from "../intl/calendar/nl-NL.mjs";
import $hkbbV$intlcalendarplPLmjs from "../intl/calendar/pl-PL.mjs";
import $hkbbV$intlcalendarptBRmjs from "../intl/calendar/pt-BR.mjs";
import $hkbbV$intlcalendarptPTmjs from "../intl/calendar/pt-PT.mjs";
import $hkbbV$intlcalendarroROmjs from "../intl/calendar/ro-RO.mjs";
import $hkbbV$intlcalendarruRUmjs from "../intl/calendar/ru-RU.mjs";
import $hkbbV$intlcalendarskSKmjs from "../intl/calendar/sk-SK.mjs";
import $hkbbV$intlcalendarslSImjs from "../intl/calendar/sl-SI.mjs";
import $hkbbV$intlcalendarsrSPmjs from "../intl/calendar/sr-SP.mjs";
import $hkbbV$intlcalendarsvSEmjs from "../intl/calendar/sv-SE.mjs";
import $hkbbV$intlcalendartrTRmjs from "../intl/calendar/tr-TR.mjs";
import $hkbbV$intlcalendarukUAmjs from "../intl/calendar/uk-UA.mjs";
import $hkbbV$intlcalendarzhCNmjs from "../intl/calendar/zh-CN.mjs";
import $hkbbV$intlcalendarzhTWmjs from "../intl/calendar/zh-TW.mjs";

var $1aa65a1533dac4d6$exports = {};


































$1aa65a1533dac4d6$exports = {
    "ar-AE": $hkbbV$intlcalendararAEmjs,
    "bg-BG": $hkbbV$intlcalendarbgBGmjs,
    "cs-CZ": $hkbbV$intlcalendarcsCZmjs,
    "da-DK": $hkbbV$intlcalendardaDKmjs,
    "de-DE": $hkbbV$intlcalendardeDEmjs,
    "el-GR": $hkbbV$intlcalendarelGRmjs,
    "en-US": $hkbbV$intlcalendarenUSmjs,
    "es-ES": $hkbbV$intlcalendaresESmjs,
    "et-EE": $hkbbV$intlcalendaretEEmjs,
    "fi-FI": $hkbbV$intlcalendarfiFImjs,
    "fr-FR": $hkbbV$intlcalendarfrFRmjs,
    "he-IL": $hkbbV$intlcalendarheILmjs,
    "hr-HR": $hkbbV$intlcalendarhrHRmjs,
    "hu-HU": $hkbbV$intlcalendarhuHUmjs,
    "it-IT": $hkbbV$intlcalendaritITmjs,
    "ja-JP": $hkbbV$intlcalendarjaJPmjs,
    "ko-KR": $hkbbV$intlcalendarkoKRmjs,
    "lt-LT": $hkbbV$intlcalendarltLTmjs,
    "lv-LV": $hkbbV$intlcalendarlvLVmjs,
    "nb-NO": $hkbbV$intlcalendarnbNOmjs,
    "nl-NL": $hkbbV$intlcalendarnlNLmjs,
    "pl-PL": $hkbbV$intlcalendarplPLmjs,
    "pt-BR": $hkbbV$intlcalendarptBRmjs,
    "pt-PT": $hkbbV$intlcalendarptPTmjs,
    "ro-RO": $hkbbV$intlcalendarroROmjs,
    "ru-RU": $hkbbV$intlcalendarruRUmjs,
    "sk-SK": $hkbbV$intlcalendarskSKmjs,
    "sl-SI": $hkbbV$intlcalendarslSImjs,
    "sr-SP": $hkbbV$intlcalendarsrSPmjs,
    "sv-SE": $hkbbV$intlcalendarsvSEmjs,
    "tr-TR": $hkbbV$intlcalendartrTRmjs,
    "uk-UA": $hkbbV$intlcalendarukUAmjs,
    "zh-CN": $hkbbV$intlcalendarzhCNmjs,
    "zh-TW": $hkbbV$intlcalendarzhTWmjs
};


export {$1aa65a1533dac4d6$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
